module.exports = __webpack_public_path__ + "img/checkbox-checked.76e30362.svg";